import { useState, useRef } from 'react';
import { uploadPhoto } from '../services/api.js';

export default function PhotoUploader({ value = [], onChange, max = 4 }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const fileRef = useRef(null);

  async function handleFiles(e) {
    setErr(null);
    const files = Array.from(e.target.files ?? []).slice(0, max - value.length);
    if (!files.length) return;
    setBusy(true);
    try {
      const keys = [];
      for (const f of files) {
        if (f.size > 8 * 1024 * 1024) throw new Error(`${f.name} exceeds 8 MB`);
        const key = await uploadPhoto(f);
        keys.push({ key, preview: URL.createObjectURL(f) });
      }
      onChange([...value, ...keys]);
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  }

  function remove(idx) { onChange(value.filter((_, i) => i !== idx)); }

  return (
    <div className="field">
      <label>Photos ({value.length}/{max})<span className="muted tiny">(required)</span></label>
      <div className="photo-uploader-grid">
        {value.map((p, i) => (
          <div key={i} className="photo-thumb">
            <img src={p.preview ?? p.url} alt={`Photo ${i + 1}`} />
            <button type="button" className="photo-remove" onClick={() => remove(i)}
              aria-label={`Remove photo ${i + 1}`}>×</button>
          </div>
        ))}
        {value.length < max && (
          <label className={`photo-add${busy ? ' is-busy' : ''}`}>
            {busy ? 'Uploading…' : '+ Add photo'}
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              multiple
              onChange={handleFiles}
              disabled={busy}
              className="visually-hidden" />
          </label>
        )}
      </div>
      {err && <div className="err">{err}</div>}
    </div>
  );
}
